import React, { useEffect, useRef, useState } from 'react';
import { LuChevronDown } from 'react-icons/lu';
import './ProductSelect.css';

// Dropdown compacto (thumbnail + nome + chevron) pra escolher de qual
// produto ver as avaliações — inclui uma opção "Todos os produtos" pra ver
// o agregado. Diferente de ProductSearch.jsx (type-ahead usado no formulário
// legado de criação manual de avaliação).
const ProductSelect = ({ products, selectedProductId, onSelect }) => {
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const selectedProduct = products.find((p) => p._id === selectedProductId) || null;

  const handleSelect = (productId) => {
    onSelect(productId);
    setOpen(false);
  };

  return (
    <div className="product-select" ref={containerRef}>
      <button type="button" className="product-select__trigger" onClick={() => setOpen((o) => !o)}>
        {selectedProduct ? (
          <>
            <img
              src={selectedProduct.variants?.[0]?.pictures?.[0]?.url}
              alt=""
              className="product-select__thumb"
            />
            <span className="product-select__label">{selectedProduct.name}</span>
          </>
        ) : (
          <span className="product-select__label">Todos os produtos</span>
        )}
        <LuChevronDown size={16} />
      </button>

      {open && (
        <div className="product-select__menu" role="listbox">
          <button
            type="button"
            role="option"
            aria-selected={!selectedProductId}
            className={`product-select__item${!selectedProductId ? ' is-active' : ''}`}
            onClick={() => handleSelect(null)}
          >
            Todos os produtos
          </button>
          {products.map((p) => (
            <button
              key={p._id}
              type="button"
              role="option"
              aria-selected={p._id === selectedProductId}
              className={`product-select__item${p._id === selectedProductId ? ' is-active' : ''}`}
              onClick={() => handleSelect(p._id)}
            >
              <img src={p.variants?.[0]?.pictures?.[0]?.url} alt="" className="product-select__thumb" />
              <span>{p.name}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default ProductSelect;
